import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useAppDispatch } from '@/store';
import { createCiterne, updateCiterne } from '@/store/thunks/citerneThunks';
import type { Citerne } from '@/types';
import { Input, Button } from '@/components/ui';

const schema = Yup.object({
  code: Yup.string().required('Code obligatoire'),
  capacite: Yup.number()
    .transform((_, v) => (v === '' || v == null ? undefined : Number(v)))
    .min(0, 'Capacité doit être positive')
    .required('Capacité obligatoire'),
});

interface CiterneFormProps {
  citerne?: Citerne | null;
  type: 'create' | 'update';
  onClose: () => void;
  onSuccess?: () => void;
}

export default function CiterneForm({ citerne, type, onClose, onSuccess }: CiterneFormProps) {
  const dispatch = useAppDispatch();

  const formik = useFormik({
    initialValues: {
      code: citerne?.code ?? '',
      capacite: citerne?.capacite != null ? String(citerne.capacite) : '',
    },
    validationSchema: schema,
    onSubmit: async (values) => {
      const payload = { ...values, capacite: Number(values.capacite) };
      if (type === 'update' && citerne?.id) {
        const res = await dispatch(updateCiterne({ ...citerne, ...payload }));
        if (updateCiterne.fulfilled.match(res)) {
          onSuccess?.();
          onClose();
        }
      } else {
        const res = await dispatch(createCiterne(payload));
        if (createCiterne.fulfilled.match(res)) {
          onSuccess?.();
          onClose();
        }
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit} className="space-y-4">
      <Input label="Code" id="code" {...formik.getFieldProps('code')} error={formik.touched.code ? formik.errors.code : undefined} />
      <Input
        label="Capacité"
        id="capacite"
        type="number"
        min={0}
        {...formik.getFieldProps('capacite')}
        error={formik.touched.capacite ? formik.errors.capacite : undefined}
      />
      <div className="flex justify-end gap-2 pt-2">
        <Button type="button" variant="outline" onClick={onClose}>Annuler</Button>
        <Button type="submit" loading={formik.isSubmitting}>{type === 'update' ? 'Modifier' : 'Créer'}</Button>
      </div>
    </form>
  );
}
